import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    button: 'text-main-black !heading-s px-0 normal-case',
    label: 'ml-2',
    icon: 'scale-x-[-1]'
  },
  variants: {
    visibility: {
      base: {},
      mobile: {
        button: 'lg:hidden'
      }
    }
  },
  defaultVariants: {
    visibility: 'base'
  }
});
